import { Grid, Chip } from '@material-ui/core'
import React, {useState} from 'react'
import SimpleCard from '../../../../components/Structure/Cards/SimpleCard'
import DisplayText from '../../../../components/Texts/DisplayText'
import AddSegmentModal from '../modals/AddSegmentModal'
import { request_create_product_subsegment, request_delete_product_subsegment } from '../requests'
import { translations as translations_esp } from '../../../../texts/esp/product-translations'
import SearchSubsegments from '../forms/SearchSubsegments'


const Subsegments = ({id, product_subsegments, onUpdateCompleted, product_segments}) => {

    const content = translations_esp.subsegments

    const [add_modal, setAddModal] = useState(false)

    const onDeleteItem = async(el) => {
        await request_delete_product_subsegment(el)
        onUpdateCompleted()
    }

    const onAddProductItem = async (el) => {
        try {
            await request_create_product_subsegment({product_id:id, sub_segment_id:el});
            onUpdateCompleted()
        } catch (error) {
            console.log(error)
        }
    }

    return(
        <SimpleCard>
        <AddSegmentModal open={add_modal} onClose={()=>setAddModal(false)} onUpdateCompleted={onUpdateCompleted} 
        onAddProductItem={onAddProductItem} content={content.modal}/>
            <Grid container spacing={2}>
                <Grid item xs={12}>                 
                    <DisplayText variant='subtitle1'>{content.title}</DisplayText>                
                </Grid>
                <Grid item xs={12}>
                    <SearchSubsegments onAddItem={()=>setAddModal(true)} existingItems={product_subsegments} 
                    onAddProductItem={onAddProductItem} content={content.search_bar} 
                    product_segments={product_segments}/>
                </Grid>
                <Grid item xs={12} >
                    <Grid container spacing={1}>
                        {product_subsegments.map((item, index)=>{
                            return(
                                <Grid item key={index}>
                                    <Chip label={item.sub_segment} onDelete={()=>onDeleteItem(item.id_product_sub_segment)} />
                                </Grid>
                            )
                        })}
                    </Grid>
                </Grid>
            </Grid>      
        </SimpleCard>
    )
}

export default Subsegments